import { Component, ElementRef, OnInit, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from 'src/app/services/settings.service';
import { ValidationService } from 'src/app/services/validation.service';
import { LanguageService } from 'src/app/services/translation.service';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-general',
    templateUrl: './general.component.html',
    styleUrls: ['./general.component.css'],
    standalone: true,
    imports: [TranslateModule, FormsModule]
})
export class GeneralComponent implements OnInit {

  isError: boolean = false;
  errorMessage: any;
  alertMessage: any;

  currLang: string;
  languageOption: string;

  defaultDateFormat = 'MM/DD/YYYY hh:mm:ss';
  dateFormat: any;

  defaultEmailAddressSeparator = '';
  emailAddressSeparator: any;
  LangOptions = [
    { label: 'English', value: 'en' },
    { label: 'Español', value: 'es' },
    { label: 'Français', value: 'fr' },
    { label: 'Português (Brasil)', value: 'pt_BR' },
    { label: 'Język polski', value: 'pl' },
    { label: '日本語', value: 'ja' },
    { label: '简体中文', value: 'zh_CN' },
    { label: '繁體中文', value: 'zh-Hant' },
    { label: '한국어', value: 'ko_KR' },
    { label: 'Русский', value: 'ru_RU' }
  ]

  //Modal
  modalRef!: MatDialogRef<any>;

  constructor(
    private settingService: SettingsService,
    private validationService: ValidationService,
    private elementRef: ElementRef,
    private dialog: MatDialog,
    private translate: TranslateService,
    private languageService:LanguageService
  ) {

    this.translate.setDefaultLang('en')
  }

  ngOnInit() {
    this.settingService.bind(this, {
      target: 'dateFormat'
      , source: 'dateFormat'
      , defaultValue: this.defaultDateFormat
    })

    this.settingService.bind(this, {
      target: 'emailAddressSeparator'
      , source: 'emailAddressSeparator'
      , defaultValue: this.defaultEmailAddressSeparator
    })


    this.getDateFormat();
    this.getEmailSeperator();
    this.currLang = this.languageService.getCurrentLanguage();
    this.languageOption = this.LangOptions.find(option => option.value === this.currLang).label;
    // Sort the array to move selected language to top
    this.LangOptions = [
      // First get the selected language option
      ...this.LangOptions.filter(lang => lang.value === this.currLang),
      // Then get all other language options
      ...this.LangOptions.filter(lang => lang.value !== this.currLang)
    ];
  }

  /* ------------------------------------------Date Format-------------------------------- */

  getDateFormat() {
    let currentDateFormat = this.settingService.get('dateFormat');

    if (currentDateFormat === null || currentDateFormat === "" || currentDateFormat === undefined) {
      this.dateFormat = this.defaultDateFormat;
    } else {
      this.dateFormat = currentDateFormat;
    }
  }

  updateDateFormat() {

    if (!this.validationService.validateNullUndefinedEmptyString(this.dateFormat)) {
      this.isError = true;
      this.errorMessage = 'Please enter date format !!';

      if (this.errorMessage == "") {
        this.elementRef.nativeElement.querySelector('.date-format-error').textContent = ""
      } else {
        this.elementRef.nativeElement.querySelector('.date-format-error').textContent = this.errorMessage;
      }
      return;
    }

    this.settingService.set('dateFormat', this.dateFormat);
  }



  /*--------------------------------------Email Seperator------------------------------------*/

  getEmailSeperator() {
    let currentEmailValidator = this.settingService.get('emailAddressSeparator');

    if (currentEmailValidator === null || currentEmailValidator === "" || currentEmailValidator === undefined) {
      this.emailAddressSeparator = this.defaultEmailAddressSeparator;
    } else {
      this.emailAddressSeparator = currentEmailValidator;
    }
  }

  updateEmailSeperator() {
    if (!this.validationService.validateNullUndefinedEmptyString(this.emailAddressSeparator)) {
      this.isError = true;
      this.errorMessage = 'Please enter email separator !!';

      if (this.errorMessage == "") {
        this.elementRef.nativeElement.querySelector('.email-separator-error').textContent = ""
      } else {
        this.elementRef.nativeElement.querySelector('.email-separator-error').textContent = this.errorMessage;
      }
      return;
    }

    this.settingService.set('emailAddressSeparator', this.emailAddressSeparator);
  }

  /*----------------------------------------- Local Setting ------------------------------------- */

  resetSettings(template: TemplateRef<any>) {

    this.settingService.reset();
    this.openAlertMod(template, "Settings cleared!");
    const languageSelect = document.getElementById('languageSelect') as HTMLSelectElement;
    if (languageSelect) {
      // Set the select value to 'en' for English
      languageSelect.value = 'en';

    }
    this.translate.use('en');

    this.dateFormat = ''
    this.emailAddressSeparator = ''
    // this.dateFormat = this.defaultDateFormat;
    // this.emailAddressSeparator = this.defaultEmailAddressSeparator;
  }


  // Modals
  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.alertMessage = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.alertMessage = "";
    }, 2000)
  }

  cancelRequest() {
    this.modalRef.close();
  }

  //-------------------lang--------------------------------

  selectLanguage(event: any) {
    this.currLang = event.target.value;
    this.languageOption = this.LangOptions.find(option => option.value === this.currLang).label;
    // Sort the array to move selected language to top
    this.LangOptions = [
      // First get the selected language option
      ...this.LangOptions.filter(lang => lang.value === this.currLang),
      // Then get all other language options
      ...this.LangOptions.filter(lang => lang.value !== this.currLang)
    ];
    // this.translate.use(this.currLang);
    this.languageService.setLanguage(this.currLang);
  }
}